// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__3EW8o","empty":"ModalGraph_empty__1DuFP"};